import React, {
  ReactElement,
  useEffect,
  useRef,
  useState,
  Fragment,
} from 'react';
import Tooltip from '@mui/material/Tooltip';
import { formatNumber } from '../../../reducer/actions/formatNumber';
import Box from '@mui/material/Box';
import { formatPrice } from '../../../reducer/actions/formatPrice';
import {isNull} from "lodash";

export const NumberCell = ({
  props,
  price,
  double,
}: {
  props: any;
  price?: boolean;
  double?: boolean;
}): ReactElement => {
  const divRef = useRef(null);
  const [tooltip, setTooltip] = useState(false);

  function getDivWidth(divRef: any) {
    if (divRef && divRef.current) {
      const divElement = divRef.current;
      const parentElement = divElement.parentNode;

      const divRect = divElement.getBoundingClientRect();
      const parentRect = parentElement.getBoundingClientRect();

      return {
        element: divRect.width,
        cell: parentRect.width,
      };
    }
    return {
      element: 0,
      cell: 0,
    };
  }

  useEffect(() => {
    setTooltip(false);
    const divWidth: { element: number; cell: number } = getDivWidth(divRef);

    if (divWidth['element'] > divWidth['cell']) {
      setTooltip(true);
    }
  });

  if (isNull(props?.value)) {
    return <></>;
  }

  // A skalár ár (pl. final_price / final_price_pp) pénzneme az original_price bucketből
  // (ez a mérvadó): HUF, ha az original_price tisztán HUF-os; egyébként EUR.
  const op = props?.row?.original_price;
  const isEur = !(op && Number(op?.HUF) > 0 && !(Number(op?.EUR) > 0));

  return (
    <Box
      ref={divRef}
      className={`whitespace-nowrap ${
        tooltip ? 'has-tooltip' : 'doesnthave-tooltip'
      }`}
      sx={{
        lineHeight: '10px',
      }}
    >
      {tooltip ? (
        <>
          <Tooltip
            disableInteractive
            title={props?.value?formatNumber(props?.value):''}
            slotProps={{
              tooltip: {
                sx: {
                  fontSize: '11px',
                },
              },
              popper: {
                modifiers: [
                  {
                    name: 'offset',
                    options: {
                      offset: [0, -14],
                    },
                  },
                ],
              },
            }}
          >
            {double ? (
              <>
                {props?.value?.EUR ? (
                  <p>
                    {formatPrice(
                      props?.value?.EUR ? props?.value?.EUR : 0,
                      true
                    )}
                  </p>
                ) : (
                  <></>
                )}
                {props?.value?.HUF ? (
                  <p>
                    {formatPrice(props?.value?.HUF ? props?.value?.HUF : 0)}
                  </p>
                ) : (
                  <></>
                )}
              </>
            ) : (
              <span>
                {price
                  ? (props?.value ? formatNumber(props?.value): '')
                  : (props?.value ? formatNumber(props?.value) : '')}
              </span>
            )}
          </Tooltip>
        </>
      ) : (
        <>
          {double ? (
            <>
              {props?.value?.EUR ? (
                <p>
                  {formatPrice(props?.value?.EUR ? props?.value?.EUR : 0, true)}
                </p>
              ) : (
                <></>
              )}
              {props?.value?.HUF ? (
                <p>{formatPrice(props?.value?.HUF ? props?.value?.HUF : 0)}</p>
              ) : (
                <></>
              )}
            </>
          ) : (
            <span>
              {price
                ? (!isNull(props?.value) ? formatPrice(props?.value > 0 ? props?.value : 0, isEur):'')
                : (props?.value ? formatNumber(props?.value > 0 ? props?.value : 0): '')}
            </span>
          )}
        </>
      )}
    </Box>
  );
};
